export const state = () => ({
    messages: [],
})

export const getters = {
    messages: (state) => {
        return state.messages
    },

    hasFlashMessages: (state) => {
        return (
            state.messages.filter((message) => message.isFlashMessage)?.length >
            0
        )
    },
}

export const mutations = {
    addMessage(state, { type, message, isFlashMessage = false, id }) {
        state.messages.push({ type, message, isFlashMessage, id })
    },

    // Clear all messages except flash messages, eg. when switching pages
    clearNormalMessages(state) {
        state.messages = state.messages.filter(
            (message) => message.isFlashMessage
        )
    },

    // Clear all messages including flash messages
    clearMessages(state) {
        state.messages = []
    },

    clearMessageById(state, messageId) {
        state.messages = state.messages.filter(
            (message) => message.id !== messageId
        )
    },
}

export const actions = {
    addMessage({ commit }, { type, message, id }) {
        commit('addMessage', { type, message, id })
    },

    addFlashMessage({ commit }, { type, message }) {
        commit('addMessage', { type, message, isFlashMessage: true })
    },

    clearMessages({ commit }, payload = {}) {
        const { messageId } = payload
        if (messageId) {
            commit('clearMessageById', messageId)
        } else {
            commit('clearMessages')
        }
    },

    clearNormalMessages({ commit }) {
        commit('clearNormalMessages')
    },

    setPersistentMessage({ commit }, message = null) {
        const flashMessage = JSON.parse(localStorage.getItem('flashMessage'))

        if (!flashMessage) {
            return
        }

        commit('addMessage', {
            type: flashMessage.type,
            message: flashMessage.message,
            isFlashMessage: true,
        })

        localStorage.removeItem('flashMessage')
    },
}
